import { gql } from '@apollo/client';

// ===================================================================
// Fragments
// ===================================================================

export const IP_WHITELIST_ENTRY_FRAGMENT = gql`
  fragment IpWhitelistEntryFields on IpWhitelistEntry {
    id
    cidr
    description
    isActive
    createdAt
  }
`;

// ===================================================================
// Queries
// ===================================================================

export const GET_IP_WHITELIST = gql`
  ${IP_WHITELIST_ENTRY_FRAGMENT}
  query GetIpWhitelist($organizationId: ID!, $page: Int, $pageSize: Int) {
    ipWhitelist(organizationId: $organizationId, page: $page, pageSize: $pageSize) {
      id
      enforcementMode
      isActive
      entries {
        ...IpWhitelistEntryFields
      }
      totalEntries
      page
      pageSize
    }
  }
`;

// ===================================================================
// Mutations
// ===================================================================

export const ADD_IP_WHITELIST_ENTRY = gql`
  ${IP_WHITELIST_ENTRY_FRAGMENT}
  mutation AddIpWhitelistEntry($organizationId: ID!, $cidr: String!, $description: String) {
    addIpWhitelistEntry(organizationId: $organizationId, cidr: $cidr, description: $description) {
      ...IpWhitelistEntryFields
    }
  }
`;

export const DELETE_IP_WHITELIST_ENTRY = gql`
  mutation DeleteIpWhitelistEntry($organizationId: ID!, $entryId: ID!) {
    deleteIpWhitelistEntry(organizationId: $organizationId, entryId: $entryId)
  }
`;

// ===================================================================
// TypeScript Types
// ===================================================================

export interface IpWhitelistEntry {
  id: string;
  cidr: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface IpWhitelist {
  id: string;
  enforcementMode: string;
  isActive: boolean;
  entries: IpWhitelistEntry[];
  totalEntries: number;
  page: number;
  pageSize: number;
}

export interface GetIpWhitelistData {
  ipWhitelist: IpWhitelist;
}

export interface GetIpWhitelistVars {
  organizationId: string;
  page?: number;
  pageSize?: number;
}

export interface AddIpWhitelistEntryData {
  addIpWhitelistEntry: IpWhitelistEntry;
}

export interface AddIpWhitelistEntryVars {
  organizationId: string;
  cidr: string;
  description?: string;
}

export interface DeleteIpWhitelistEntryData {
  deleteIpWhitelistEntry: boolean;
}

export interface DeleteIpWhitelistEntryVars {
  organizationId: string;
  entryId: string;
}
